import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { _MEETINGS_STORE, MUTATIONS, MEETING_STORE_ACTION } from '../values/meetings.values';
import { MeetingsService } from '../services/meetings.service';
import { RequestMeetingFront } from '../models/request-meeting-front.model';
import { RequestMeeting } from '../models/request-meeting.model'
import { Student } from '../models/student-front.model';
import { RequestSet } from '../models/request-set.model';
import { ClassItem } from '@/core/models/class.model'
import WebSocketMessageResponse from '@/content/models/web-socket-message-response.model';
import MeetingInformationResponse from '../models/meeting-information-response.model';
import Vue from 'vue';
import {CallsService} from '@/components/calls/services/calls.service';
import {ShareTaskData} from '@/meetings/interfaces/share-task-data.interface';

export const MEETINGS_STORE = _MEETINGS_STORE;

@Module({ namespaced: true })
export class MeetingsStore extends VuexModule {

  /* State */
  public sets: Array<RequestMeetingFront> = [];
  public currentClass: ClassItem = {
    className:'ClassName',
    classId:0
  };
  public meetingPage: string = '';
  public presentationModeMeetings : number[] = [];
  public currentCalls : number[] = [];
  public initialPresentationModeMessage : WebSocketMessageResponse = null;
  public currentMeetingData = {
    classId:0,
    meetingId:0,
    meetingType:null,
    meetingTypeMenu:null,
    studentToggle: false,
    editUrl: null,
    viewUrl: null
  };
  public meetingsClasses = null;
  public presentationModeViewerType : string = '';
  public multiplePresentationModeViewerTypes : string[] = [];
  public transparentBoardPath : string = '';
  public presentationModePageSizeInfo : any = {};
  public isWhiteboardTransparency : boolean = false;
  public isInitialWhiteboardTransparency : boolean = true;
  public isTransparencyManually : boolean = false;
  public currentPresentationSection : {
    current?: {classId?: number, courseId?: number, sectionId?: number, title?: string},
    perCourse?: [{classId: number, courseId: number, sectionId: number, title: string}?]
  } = {current: {}, perCourse: []};
  public mainMeetingType: number = 0;
  public currentPageSizes : {[key: number]: any} = {};
  public currentMeetingUsers : {[key: string]: any}[] = [];
  public currentBoardUser : {[key: string]: any} = {};
  public currentActiveUsers : string[] = [];
  public isPresentationNavigation : boolean = true;
  public presentationModeUserFilter: boolean = true;
  public shareTaskData: ShareTaskData = {} as ShareTaskData;  
  public isValidatedPresentationModeSession : boolean = false;
  public isPresentationModeGuestTeacher : boolean = false;
  public isActivePresenterTeacher : boolean = false;
  public isOtherSession : boolean = false;
  public presenterTeacherInformation : MeetingInformationResponse = null;
  public isShowingChangePresenter : boolean = false;
  public presentationModeScrollInfo : any = {};
  public presentationModeLayoutInfo : any = {};
  public originalPagesSize : {[key: string]: any} = {};
  public meetingSessionId: string = '';
  public edupadDocumentId: string = '';
  public loadedBoardsInDom : number = 0;
  public initialLoadedBoardsEmited: boolean = false;
  public lastTextMessage: any = {};
  public roomClasses: Array<Object> = [];

  /* Mutations */
  @Mutation
  public setSetsM(sets:Array<RequestMeetingFront>){
    this.sets = sets;
  }

  @Mutation
  public setCurrentClassM(currentClass:any){
    if(currentClass)
      this.currentClass = currentClass;
  }

  @Mutation
  public updateSetM({changedSet,action}:{changedSet:RequestMeetingFront,action:MEETING_STORE_ACTION}){
    switch (action) {
      case MEETING_STORE_ACTION.ADD:
        this.sets.splice(2,0,changedSet);
        break;

      case MEETING_STORE_ACTION.CHANGE:
        this.sets.map(set => {
          var s = set;
          if(set.meetingId == changedSet.meetingId){
            s = changedSet;
          }
          return s;
        });
        break;

      case MEETING_STORE_ACTION.DELETE:
        this.sets.splice(this.sets.findIndex(set => set.meetingId == changedSet.meetingId),1);
        break;

      default:
        break;
    }
  }

  @Mutation
  public updateGroupM({changedGroup,action}:{changedGroup:RequestMeetingFront,action:MEETING_STORE_ACTION}){
    var parentId = this.sets.findIndex(set => set.meetingId == changedGroup.meetingSetId);
    switch (action) {
      case MEETING_STORE_ACTION.ADD:
        if(!this.sets[parentId].rooms)
          this.sets[parentId].rooms = [];
        this.sets[parentId].rooms.unshift(changedGroup);
        break;

      case MEETING_STORE_ACTION.CHANGE:
        this.sets[parentId].rooms.map(group => {
          var g = group;
          if(group.meetingId == changedGroup.meetingId){
            g = changedGroup;
          }
          return g;
        });
        break;

      case MEETING_STORE_ACTION.DELETE:
        this.sets[parentId].rooms.splice(this.sets[parentId].rooms.findIndex(group => group.meetingId == changedGroup.meetingId),1);
        break;

      default:
        break;
    }
  }

  @Mutation
  public updateStudentM({changedStudent,meetingId,meetingSetId,action}:
    {changedStudent:Student,meetingId:number,meetingSetId:number,action:MEETING_STORE_ACTION}){

    var setParentId = this.sets.findIndex(set => set.meetingId == meetingSetId);
    var groupParentId = this.sets[setParentId].rooms.findIndex(group => group.meetingId == meetingId);

    switch (action) {
      case MEETING_STORE_ACTION.ADD:
        if(!this.sets[setParentId].rooms[groupParentId].students)
          this.sets[setParentId].rooms[groupParentId].students = [];
        this.sets[setParentId].rooms[groupParentId].students.push(changedStudent);
        break;

      case MEETING_STORE_ACTION.DELETE:
        var studentIndex = this.sets[setParentId].rooms[groupParentId].students.findIndex(st => st.id == changedStudent.id);
        this.sets[setParentId].rooms[groupParentId].students.splice(studentIndex,1);
        break;

      default:
        break;
    }
  }

  @Mutation
  public cleanMeetingPage() : void {
    this.meetingPage = '';
  }

  @Mutation
  public updateCurrentCalls({meetingId, command} : {meetingId: number, command: string}){
    if (command === 'add'){
      if(!this.currentCalls.includes(meetingId)){
        this.currentCalls.push(meetingId);
      }
    }else if (command === 'del'){
      if(this.currentCalls.includes(meetingId)){
        const index = this.currentCalls.indexOf(meetingId);
        this.currentCalls.splice(index, 1);
      }
    }else if (command === 'reset'){
      this.currentCalls = [];
    }
  }

  @Mutation
  public setCurrentCalls(calls){
    this.currentCalls = calls;
  }

  @Mutation
  public updateMeetingPage(meetingPage: string) : void {
    if(!meetingPage){
      return;
    }
    this.meetingPage = meetingPage;
  }

  @Mutation
  public addPresentationModeMeeting(roomId : number){
    if(roomId && !this.presentationModeMeetings.includes(roomId)){
      this.presentationModeMeetings.push(roomId);
    }
  }

  @Mutation
  public removePresentationModeMeeting(roomId : number){
    if(!roomId){
      return;
    }

    let roomIndex = this.presentationModeMeetings.findIndex(meeting => meeting === roomId);
    if(roomIndex >= 0){
      this.presentationModeMeetings.splice(roomIndex, 1);
    }
  }

  @Mutation
  public updateInitialPresentationModeMessage(initialPresentationModeMessage : WebSocketMessageResponse){
    this.initialPresentationModeMessage = initialPresentationModeMessage;
  }

  @Mutation
  public updateCurrentMeetingData(currentMeetingData:any){
    if(currentMeetingData)
      this.currentMeetingData = currentMeetingData;
  }

  @Mutation
  public updatePresentationModeViewerType(presentationModeViewerType : string){
    this.presentationModeViewerType = presentationModeViewerType;
  }

  @Mutation
  public updateMultiplePresentationModeViewerTypes(multiplePresentationModeViewerTypes: string[]) {
    this.multiplePresentationModeViewerTypes = multiplePresentationModeViewerTypes;
  }

  @Mutation
  public setMeetingsClasses(value) {
    this.meetingsClasses = value;
  }

  @Mutation
  public updateTransparentBoardPath(boardPath : string) {
    this.transparentBoardPath = boardPath;
  }

  @Mutation
  public updatePresentationModePageSizeInfo(presentationModePageSizeInfo : any) {
    this.presentationModePageSizeInfo = {...this.presentationModePageSizeInfo, ...presentationModePageSizeInfo};
  }

  @Mutation
  public updateWhiteboardTransparency(isWhiteboardTransparency : boolean) {
    this.isWhiteboardTransparency = isWhiteboardTransparency;
  }

  @Mutation
  public updateInitialWhiteboardTransparency(isInitialWhiteboardTransparency : boolean) {
    this.isInitialWhiteboardTransparency = isInitialWhiteboardTransparency;
  }

  @Mutation
  public updateCurrentPresentationSection(currentPresentationSection : {classId: number, courseId: number, sectionId: number, title: string, materialId?: number, type?: string}) {
    Vue.set(this.currentPresentationSection, 'current', currentPresentationSection);
    if (!this.currentPresentationSection.perCourse) {
      Vue.set(this.currentPresentationSection, 'perCourse', []);
    }
    if (!currentPresentationSection || Object.keys(currentPresentationSection).length === 0) {
      Vue.set(this.currentPresentationSection, 'perCourse', []);
      return;
    }
    const index = this.currentPresentationSection.perCourse.findIndex(entry => entry.courseId === currentPresentationSection.courseId);
    if (index === -1) {
      this.currentPresentationSection.perCourse.push(currentPresentationSection);
    } else {
      Vue.set(this.currentPresentationSection.perCourse, index, currentPresentationSection);
    }
  }

  @Mutation
  public setMainMeetingType(value:number) {
      this.mainMeetingType = value;
  }

  @Mutation
  public updateCurrentPageSizes({key, value} : {key: number, value: any}) {
      Vue.set(this.currentPageSizes, key, value);
  }

  @Mutation
  public addCurrentPageSizes(currentPageSizes : {[key: number]: any}) {
      this.currentPageSizes = currentPageSizes;
  }

  @Mutation
  public updateCurrentMeetingUsers(users : {[key: string]: any}[]) : void {
    users.forEach(user => {
      this.currentMeetingUsers.push({
        id: user.id,
        fullName: user.fullName,
        username: user.userId
      });
    });
  }

  @Mutation
  public updateCurrentBoardUser(currentBoardUser : {[key: string]: any}) {
      this.currentBoardUser = currentBoardUser;
  }

  @Mutation
  public addCurrentMeetingActiveUser(username : string) : void {
    if(!this.currentActiveUsers.includes(username)){
      this.currentActiveUsers.push(username);
    }
  }

  @Mutation
  public removeCurrentMeetingActiveUser(username : string) : void {
    let index : number = this.currentActiveUsers.findIndex(user => user === username);
    if(index < 0){
      return;
    }
    this.currentActiveUsers.splice(index, 1);
  }

  @Mutation
  public clearCurrentMeetingActiveUsers() : void {
    this.currentActiveUsers = [];
  }

  @Mutation
  public updateIsTransparencyManually(isTransparencyManually : boolean){
    this.isTransparencyManually = isTransparencyManually;
  }

  @Mutation
  public removeCurrentMeetingUsers() : void {
    this.currentMeetingUsers = [];
  }

  @Mutation
  public updatePresentationNavigation(isPresentationNavigation : boolean) : void {
    this.isPresentationNavigation = isPresentationNavigation;
  }

  @Mutation
  public updatePresentationModeUserFilter(presentationModeUserFilter : boolean){
    this.presentationModeUserFilter = presentationModeUserFilter;
  }

  @Mutation
  public setShareTaskData(shareTaskData: ShareTaskData) {
    this.shareTaskData = shareTaskData;
  }

  @Mutation
  public clearPresentationModeMeetings(){
    this.presentationModeMeetings = [];
  }

  @Mutation
  public updatePresentationModeGuestTeacher(isPresentationModeGuestTeacher : boolean){
    this.isPresentationModeGuestTeacher = isPresentationModeGuestTeacher;
  }

  @Mutation
  public updateValidatedPresentationModeSession(isValidatedPresentationModeSession : boolean){
    this.isValidatedPresentationModeSession = isValidatedPresentationModeSession;
  }

  @Mutation
  public updateActivePresenterTeacher(isActivePresenterTeacher : boolean){
    this.isActivePresenterTeacher = isActivePresenterTeacher;
  }

  @Mutation
  public updateOtherSession(isOtherSession : boolean){
    this.isOtherSession = isOtherSession;
  }

  @Mutation
  public updatePresenterTeacherInformation(presenterTeacherInformation : MeetingInformationResponse){
    this.presenterTeacherInformation = presenterTeacherInformation;
  }

  @Mutation
  public updateShowingChangePresenter(isShowingChangePresenter : boolean){
    this.isShowingChangePresenter = isShowingChangePresenter;
  }

  @Mutation
  public updateOriginalPagesSize({documentHash, pageNumber, data} : {documentHash: string, pageNumber: number, data: any} ) {
    if(!this.originalPagesSize[documentHash]){
      this.originalPagesSize[documentHash] = [];
    }
    this.originalPagesSize[documentHash].push(data);
    //let hashData = [...this.originalPagesSize[documentHash]];
    //Vue.set(this.originalPagesSize, documentHash, hashData);
  }

  @Mutation
  public cleanOriginalPagesSize({documentHash} : {documentHash: string} ) {
    if(this.originalPagesSize[documentHash]){
      delete this.originalPagesSize[documentHash];
    }
  }

  @Mutation
  public setMeetingSessionId(meetingSessionId: string): void {
    this.meetingSessionId = meetingSessionId;
  }

  @Mutation
  public setEducpadDocumentId(edupadDocumentId: string): void {
    this.edupadDocumentId = edupadDocumentId;
  }
  
  @Mutation
  public updateLoadedBoardsInDom(loadedBoardsInDom : number) {
    this.loadedBoardsInDom = loadedBoardsInDom;
  }

  @Mutation
  public updatePresentationModeScrollInfo(presentationModeScrollInfo : any){
    this.presentationModeScrollInfo = presentationModeScrollInfo;
  }

  @Mutation
  public updatePresentationModeLayoutInfo(presentationModeLayoutInfo : any){
    this.presentationModeLayoutInfo = presentationModeLayoutInfo;
  }

  @Mutation
  public updateInitialLoadedBoardsEmited(initialLoadedBoardsEmited : boolean) {
    this.initialLoadedBoardsEmited = initialLoadedBoardsEmited;
  }

  @Mutation
  public updateLastTextMessage(textMessage: any) {
    this.lastTextMessage = textMessage;
  }

  @Mutation
  public setAllRoomClassesM(roomClasses){
    this.roomClasses = roomClasses;
  }

  @Mutation
  public updateClassNameM({ classId, className }){
    this.roomClasses = this.roomClasses.map(el => {
      return el['classId'] == classId ? { ...el, className } : el;
    })
  }

  /* Actions */
  @Action({rawError:true})
  public getSetsA(classId:number = this.currentClass.classId): Promise<any>{
    return new Promise((resolve,reject) => {
      MeetingsService.getSetsFromClass(classId).then((res:any) => {
          this.context.commit(MUTATIONS.SET_SETS_M, res);
          if(res[0])
            this.context.commit(MUTATIONS.SET_CURRENT_CLASS_M, { className:res[0].className, classId:res[0].classId })
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  @Action({rawError:true})
  public updateSetA({changedSet,action}:
    {changedSet:RequestMeetingFront,action:MEETING_STORE_ACTION}): Promise<any>{
    return new Promise((resolve,reject) => {
      switch (action) {
        case MEETING_STORE_ACTION.ADD:
          var set = new RequestSet({
            name:changedSet.name,
            classId:this.currentClass.classId
          });
          MeetingsService.createSet(set).then((res:any) => {
            changedSet.meetingId = res.meetingId;
            this.context.commit(MUTATIONS.UPDATE_SET_M, {changedSet, action});
            resolve(res);
          }).catch(e => {
            reject(e);
          });
          break;

        case MEETING_STORE_ACTION.CHANGE:
          var set = new RequestSet({
            name:changedSet.name,
            active:changedSet.active
          });
          MeetingsService.updateSet(set,changedSet.meetingId).then(res => {
            this.context.commit(MUTATIONS.UPDATE_SET_M, {changedSet, action});
            resolve(res);
          }).catch(e => {
            reject(e);
          });
          break;

        case MEETING_STORE_ACTION.DELETE:
          MeetingsService.deleteGroupOrSet(changedSet.meetingId).then(res => {
            this.context.commit(MUTATIONS.UPDATE_SET_M, {changedSet, action});
            resolve(res);
          }).catch(e => {
            reject(e);
          });
          break;

        default:
          break;
      }
    });
  }

  @Action({rawError:true})
  public updateGroupA({changedGroup,action}:
    {changedGroup:RequestMeetingFront,action:MEETING_STORE_ACTION}): Promise<any>{
    return new Promise((resolve,reject) => {
      switch (action) {
        case MEETING_STORE_ACTION.ADD:
          var group = new RequestMeeting({
            name: changedGroup.name,
            description: changedGroup.description,
            type: changedGroup.type,
            meetingId: changedGroup.meetingId,
            id: this.currentClass.classId,
            setMeetingId: changedGroup.meetingSetId
          });
          MeetingsService.createOrUpdateGroup(group).then((res:any) => {
            changedGroup.meetingId = res.meetingId;
            this.context.commit(MUTATIONS.UPDATE_GROUP_M, {changedGroup, action});
            resolve(res);
          }).catch(e => {
            reject(e);
          });
          break;

        case MEETING_STORE_ACTION.CHANGE:
          var group = new RequestMeeting({
            name: changedGroup.name,
            description: changedGroup.description,
            type: changedGroup.type,
            meetingId: changedGroup.meetingId,
            id: this.currentClass.classId,
            setMeetingId: changedGroup.meetingSetId
          });
          MeetingsService.createOrUpdateGroup(group).then(res => {
            this.context.commit(MUTATIONS.UPDATE_GROUP_M, {changedGroup, action});
            resolve(res);
          }).catch(e => {
            reject(e);
          });
          break;

        case MEETING_STORE_ACTION.DELETE:
          MeetingsService.deleteGroupOrSet(changedGroup.meetingId).then(res => {
            this.context.commit(MUTATIONS.UPDATE_GROUP_M, {changedGroup, action});
            resolve(res);
          }).catch(e => {
            reject(e);
          });
          break;

        default:
          break;
      }
    });
  }

  @Action({rawError:true})
  public updateStudentA({changedStudent,meetingId,meetingSetId,action}:
    {changedStudent:Student,meetingId:number,meetingSetId:number,action:MEETING_STORE_ACTION}): Promise<any>{
    return new Promise((resolve,reject) => {
      switch (action) {
        case MEETING_STORE_ACTION.ADD:
          MeetingsService.addStudentToGroup(changedStudent.id,meetingId).then(res => {
            this.context.commit(MUTATIONS.UPDATE_STUDENT_M, {changedStudent,meetingId,meetingSetId,action});
            resolve(res);
          }).catch(e => {
            reject(e);
          });
          break;

        case MEETING_STORE_ACTION.DELETE:
          MeetingsService.deleteStudentInGroup(changedStudent.id,meetingId).then(res => {
            this.context.commit(MUTATIONS.UPDATE_STUDENT_M, {changedStudent,meetingId,meetingSetId,action});
            resolve(res);
          }).catch(e => {
            reject(e);
          });
          break;

        default:
          break;
      }
    });
  }

  @Action({rawError:true})
  public obtainMeetingUsers(meetingId : number) : Promise<void> {
    return new Promise((resolve, reject) => {
      MeetingsService.getMeetingStudentsList(meetingId).then((users : any) => {
        this.context.commit(MUTATIONS.UPDATE_CURRENT_MEETING_USERS, users);
        resolve();
      }).catch(() => {
        reject();
      });
    })
  }

  @Action({rawError:true})
  public fetchLiveMeetings() : Promise<void> {
    let ids = this.meetingsClasses.map(el => el.meetingId);
    return new Promise((resolve, reject) => {
      CallsService.getLiveCalls(ids).then((liveCalls)=>{
        if (Array.isArray(liveCalls) && liveCalls.length>0){
          liveCalls.map(c => {
            this.context.commit(MUTATIONS.UPDATE_CURRENT_CALLS, {meetingId: c, command: 'add'});
          });
        }else{
          this.context.commit(MUTATIONS.UPDATE_CURRENT_CALLS, {command: 'reset'});
        }
        resolve();
      }).catch(() => {
        reject();
      });
    })
  }

  @Action({rawError:true})
  public getAllRoomClassesA(): Promise<any>{
    return new Promise((resolve,reject) => {
      MeetingsService.getUserClassRooms().then((res:any) => {
          this.context.commit(MUTATIONS.SET_ALL_ROOM_CLASSES, res);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  /* Initial State */
  @Mutation
  public initState(state) {
    this.sets = [];
    this.currentClass = {
      className:'ClassName',
      classId:0
    };
    this.meetingPage = '';
    this.presentationModeMeetings = [];
    this.currentCalls = [];
    this.initialPresentationModeMessage = null;
    this.currentMeetingData = {
      classId:0,
      meetingId:0,
      meetingType:null,
      meetingTypeMenu:null,
      studentToggle: false,
      editUrl: null,
      viewUrl: null
    };
    this.meetingsClasses = null;
    this.presentationModeViewerType = '';
    this.multiplePresentationModeViewerTypes = [];
    this.transparentBoardPath = '';
    this.presentationModePageSizeInfo = {};
    this.isWhiteboardTransparency = false;
    this.isInitialWhiteboardTransparency = true;
    this.isTransparencyManually = false;
    this.currentPresentationSection = {current: {}, perCourse: []};
    this.mainMeetingType = 0;
    this.currentPageSizes = {};
    this.currentMeetingUsers = [];
    this.currentBoardUser = {};
    this.currentActiveUsers = [];
    this.isPresentationNavigation = true;
    this.presentationModeUserFilter = true;
    this.shareTaskData = {} as ShareTaskData;
    this.isValidatedPresentationModeSession = false;
    this.isPresentationModeGuestTeacher = false;
    this.isActivePresenterTeacher = false;
    this.isOtherSession = false;
    this.presenterTeacherInformation = null;
    this.isShowingChangePresenter = false;
    this.presentationModeScrollInfo = {};
    this.presentationModeLayoutInfo = {};
    this.originalPagesSize = {};
    this.meetingSessionId = '';
    this.loadedBoardsInDom = 0;
    this.initialLoadedBoardsEmited = false;
    this.lastTextMessage= {};
    this.roomClasses = [];
  }
}
